/* Existing Royal Coffee Klaviyo forms/onsite tracking and Zoho SalesIQ chat. */
(function () {
  'use strict';

  var shopify = window.Shopify;
  if (!shopify || shopify.designMode || window.rcEngagementInitialized) return;
  var current = new URL(window.location.href);
  if (!/^(www\.)?royalcoffee\.com$/.test(current.hostname) || current.searchParams.has('preview_theme_id')) return;

  // Vendor runtimes inspect URLs themselves. Keep them off private portal pages.
  var privatePath = /\/(?:account|customer_authentication|checkouts?|orders|gift_cards|apps|search)(?:\/|$)|\/pages\/(?:my-account|online-orders|paid-invoices|unpaid-invoices|bills-of-lading|customer-positions|customer-usage|historical-positions|organic-certificates)(?:\/|$)/i;
  var sensitiveKey = /(?:^|_)(?:token|key|email|customer|contact|invoice|order|profile|signature|hmac|password|secret|authorization)(?:_|$)/i;
  function isSensitiveKey(key) {
    return sensitiveKey.test(key.replace(/([a-z0-9])([A-Z])/g, '$1_$2').replace(/[^a-zA-Z0-9]+/g, '_'));
  }
  function privateUrl(url) {
    if (privatePath.test(url.pathname)) return true;
    var fragment = new URLSearchParams(url.hash.slice(1).replace(/^.*\?/, ''));
    return Array.from(url.searchParams.keys()).concat(Array.from(fragment.keys())).some(isSensitiveKey);
  }
  if (privateUrl(current)) return;
  if (document.referrer) {
    try {
      if (privateUrl(new URL(document.referrer))) return;
    } catch (error) { /* Ignore malformed referrers. */ }
  }

  window.rcEngagementInitialized = true;
  var klaviyoRequested = false;
  var salesIqRequested = false;
  var reloading = false;
  var companyFieldAdded = false;
  var newsletterRequested = current.searchParams.get('newsletter') === 'RjYpEi';
  var status = document.querySelector('[data-rc-newsletter-status]');
  var form = document.querySelector('[data-rc-klaviyo-form]');

  function newsletterStatus(message) {
    if (status) status.textContent = message;
  }

  if (form && status) {
    var observer = new MutationObserver(function () {
      if (form.querySelector('form, input, iframe')) {
        status.hidden = true;
        observer.disconnect();
      }
    });
    observer.observe(form, { childList: true, subtree: true });
  }

  function permissions() {
    try {
      var privacy = shopify.customerPrivacy;
      return {
        analytics: !!(privacy && privacy.analyticsProcessingAllowed()),
        marketing: !!(privacy && privacy.marketingAllowed())
      };
    } catch (error) { return { analytics: false, marketing: false }; }
  }

  var newsletterOpening = false;
  function openNewsletter() {
    newsletterOpening = false;
    var allowed = permissions();
    if (reloading || !allowed.analytics || !allowed.marketing) return;
    // The supported queue also handles clicks before Klaviyo finishes loading.
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'RjYpEi']);
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var trigger = event.target.closest && event.target.closest('a.klaviyo_form_trigger');
    if (!trigger) return;
    var allowed = permissions();
    // Retain the link destination when the existing consent gate blocks forms.
    if (reloading || !allowed.analytics || !allowed.marketing) return;
    event.preventDefault();
    if (newsletterOpening) return;

    var mobileNav = trigger.closest('[data-mobile-nav][data-open="true"]');
    var close = mobileNav && mobileNav.querySelector('[data-mobile-nav-close]');
    if (close) {
      newsletterOpening = true;
      // Wait for Empire to release its focus trap before Klaviyo takes focus.
      var closed = new MutationObserver(function () {
        if (mobileNav.dataset.open === 'true') return;
        closed.disconnect();
        openNewsletter();
      });
      closed.observe(mobileNav, { attributes: true, attributeFilter: ['data-open'] });
      close.click();
    } else {
      openNewsletter();
    }
  });

  function addScript(id, src, onerror) {
    var script = document.createElement('script');
    script.id = id;
    script.async = true;
    script.src = src;
    script.referrerPolicy = 'origin';
    if (onerror) script.onerror = onerror;
    document.head.appendChild(script);
  }

  function stopSalesIqTracking() {
    var iq = window.$zoho && window.$zoho.salesiq;
    if (iq && iq.tracking && typeof iq.tracking.off === 'function') iq.tracking.off();
  }

  function syncConsent() {
    if (reloading) return;
    var allowed = permissions();
    var klaviyoAllowed = allowed.analytics && allowed.marketing;

    if ((klaviyoRequested && !klaviyoAllowed) || (salesIqRequested && !allowed.analytics)) {
      // Removing a script does not stop its timers/listeners. A fresh document
      // enforces the new Shopify permission without an undocumented vendor API.
      reloading = true;
      try { stopSalesIqTracking(); } finally { window.location.reload(); }
      return;
    }

    if (klaviyoAllowed && !klaviyoRequested) {
      klaviyoRequested = true;
      newsletterStatus('Loading newsletter signup…');
      if (!document.querySelector('script[src*="static.klaviyo.com/onsite/"]')) {
        addScript('rc-klaviyo', 'https://static.klaviyo.com/onsite/js/VPVkpU/klaviyo.js', function () {
          newsletterStatus('Newsletter signup is temporarily unavailable. Please try again later.');
        });
      }
    } else if (!klaviyoAllowed) {
      newsletterStatus('Newsletter signup requires analytics and marketing cookies. You can update your cookie preferences to load the form.');
    }

    // Menu links from pages where marketing scripts are disabled arrive here.
    if (klaviyoAllowed && newsletterRequested) {
      newsletterRequested = false;
      openNewsletter();
    }

    if (allowed.analytics && !salesIqRequested) {
      salesIqRequested = true;
      if (document.querySelector('#zsiqscript, script[src*="salesiq.zoho.com/widget"]') || (window.$zoho && window.$zoho.salesiq)) return;
      window.$zoho = window.$zoho || {};
      window.$zoho.salesiq = {
        widgetcode: '5baafedae26634aaddfcc1cda89655bd92ce681639d8152cc7ceffd02c432afe1a2010ab7b6727677d37b27582c0e9c4',
        values: {},
        ready: function () {
          if (!permissions().analytics) {
            stopSalesIqTracking();
            return;
          }
          if (!companyFieldAdded) {
            companyFieldAdded = true;
            window.$zoho.salesiq.customfield.add({
              name: 'Company Name', hint: 'Enter your company name', type: 'text',
              required: 'true', maxlength: '100', visibility: 'both'
            });
          }
        }
      };
      if (!document.getElementById('zsiqwidget')) {
        var widget = document.createElement('div');
        widget.id = 'zsiqwidget';
        document.body.appendChild(widget);
      }
      addScript('zsiqscript', 'https://salesiq.zoho.com/widget');
    }
  }

  document.addEventListener('visitorConsentCollected', syncConsent);
  if (shopify.customerPrivacy) {
    syncConsent();
  } else if (typeof shopify.loadFeatures === 'function') {
    newsletterStatus('Loading newsletter signup…');
    try {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) syncConsent();
        else newsletterStatus('Newsletter signup is temporarily unavailable. Please try again later.');
      });
    } catch (error) {
      newsletterStatus('Newsletter signup is temporarily unavailable. Please try again later.');
    }
  }
})();
